import { render, staticRenderFns } from "./SecaoResultado.vue?vue&type=template&id=3f3bcc53&"
import script from "./SecaoResultado.vue?vue&type=script&lang=js&"
export * from "./SecaoResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports